import { render } from "./Contacts.vue?vue&type=template&id=72215c17"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.sass?vue&type=style&index=0&lang=sass&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__